import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {Cuenta, Empresa} from "../../_model/";
import {config} from "../../../../environments/config";
import {Observable, BehaviorSubject, throwError, ReplaySubject} from "rxjs";
import {catchError} from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

@Injectable({
    providedIn: 'root'
})
export class EmpresaService {
    private dataEmpresa$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    private logobase64$ = new ReplaySubject<any>();

    constructor(private http: HttpClient,
                private _toastrService: ToastrService) {
    }

    getAll(): Observable<any> {
        const params = new HttpParams()
            .set('empresa', String(1));
        return this.http.post<any[]>(`${config.apiUrl}/empresa/get`, params);
    }
    /*
    DATOS DE LA EMPRESA
     */
    getEmpresa() {
        const params = new HttpParams()
            .set('empresa', '1');
        this.http.post<any>(`${config.apiUrl}/empresa/getempresa`, params).toPromise().then(
            (res => {
                this.dataEmpresa$.next(res.list);
            //     console.log(res.list);
            }), catchError((err) => this.error(err))
        );
    }
    /*
   DATOS DE LA SOLO NOM EMPRESA
    */
    getEmpresaNombre() {
        const params = new HttpParams()
            .set('empresa', '1');
        return this.http.post<any>(`${config.apiUrl}/empresa/getempresanom`, params)
            .toPromise()
            .then(res => <Empresa>res.list)
            .then(data => {
                return data;
            });
        /*this.http.post<any>(`${config.apiUrl}/empresa/getempresanom`, params).toPromise().then(
            (res => {
                //this.dataEmpresa$.next(res.list);
            }), catchError((err) => this.error(err))
        );*/
    }
    getDataEmpresa(): Observable<any> {
        return this.dataEmpresa$.asObservable();
    }
    /*
    LOGO EN FORMATO BASE64 OBSERVABLE
     */
    getLogoBase64() {
      //  this.getEmpresaNombre();
       // this.logobase64$.next(this.http.get<any>(`${config.apiUrl}/empresa/logobase64`)); // define observador
        return this.http.get<any>(`${config.apiUrl}/empresa/logobase64`);
    }

     generarLogobase64(){
        return this.http.get<any>(`${config.apiUrl}/empresa/logobase64`)
            .subscribe( res=> {
                //console.log(res.data.logo)
                this.logobase64$.next(res.data.logo)
            });
    }
    public get getlogoComprimido(){
        return this.logobase64$.asObservable();
    }
    /*
    LOGO EN FORMATO IMAGEN
     */
    getLogo(): Observable<any> {
        return this.http.get<any[]>(`${config.apiUrl}/empresa/logo`);
    }

    filterEmpresa() {
        const params = new HttpParams()
            .set('empresa', String(1));
        return this.http.post<any>(`${config.apiUrl}/empresa/get`, params)
            .toPromise()
            .then(res => <Empresa>res.list)
            .then(data => {
                return data;
            });
    }

    private error(error): Observable<never> {
        let errorMessage;
        if (error) {

            setTimeout(() => {
                this._toastrService.error(
                    'En estos momentos no podemos atenderte intente mas tarde. revisa tu conexión a internet y vuelve a intentarlo  Gracias! 👋 ', '',
                    {toastClass: 'toast ngx-toastr', closeButton: true}
                );
            }, 1500);
            errorMessage = `Error: code ${error.message}`;
        }
        return throwError(errorMessage);
    }

    async presentAlert(titulo: string, mensaje: string) {

    }
}
